<template>
  <div>

<!--    <loading :active.sync="isLoading" opacity="0.9"></loading>-->
    <KTCodePreview class="px-10">
      <template v-slot:title>
        <span>{{$t("EventLogs")}}</span>
      </template>
      <template v-slot:preview>
        <!-- row justify-content-center -->
        <div class="">

          <b-row class="mb-3">
            <b-col cols="4">
              <p> {{$t('SearchText')}}</p>
              <b-input-group class="mb-2" size="sm">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input v-model="searchText"
                              :placeholder="$t('SearchBySubmissionId')"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col cols="3">
              <p>{{$t('EventType')}}</p>
              <b-form-select size="sm" :options="options" v-model="searchEvent"></b-form-select>
<!--              <v-select label="Status" solo :items="items"></v-select>-->
            </b-col>
            <b-col cols="3">
              <p>{{$t('EventDateRange')}}</p>

              <date-picker
                  value-type="format" format="YYYY-MM-DD"
                  class="w-100" v-model="dateRange" type="date" range
                           placeholder=""></date-picker>
          </b-col>
          <b-col cols="2">

            <div class="w-100 h-100"  style="position:relative">
              <div style="position: absolute;bottom:7px; left:0;" class="">
                <b-button class="float-right" variant="outline-primary" size="sm" @click="search()">
                  <b-icon icon="search"></b-icon>
                  {{ $t("Search") }}
                </b-button>
              </div>

            </div>
          </b-col>
        </b-row>

          <div class="mb-1" style="text-align: right">
            <b>{{ $t("TotalCount")}}: {{ eventLogs.length }}</b>
          </div>
          <v-data-table
              loading-text="Getting the data."
              :loading="isLoading"
              :headers="headers"
              :items="eventLogs"
              :page.sync="page"
              hide-default-footer>
<!--
            <template v-slot:item.firstName="{ item }">
              <p class="mb-0">
                {{item.firstName}}
              </p>
            </template>
            -->

            <template v-slot:item.createTime="{ item }">
              <p class="mb-0 font-size-sm">
<!--                {{$moment( item.createTime ).fromNow()}}-->
                {{ item.createTime | datetimeFormat }}
              </p>
            </template>

            <template v-slot:item.eventTrigger="{ item }">
              <p class="mb-0">
                {{eventTypeText[ item.eventTrigger ] ? eventTypeText[ item.eventTrigger ] : item.eventTrigger }}
              </p>
            </template>



          </v-data-table>


          <div class="text-center mt-10">
<!--            <v-pagination
                v-model="page"
                :length="pageLength"
                color="#3699ff"
                :total-visible="7"
            ></v-pagination>-->

            <b-pagination-nav
                align="center"
                size="lg"
                v-model="page"
                :number-of-pages="lastPageNumber"
                base-url="#"
                first-number
                last-number
                :limit="10"
                last-class="hide"
            ></b-pagination-nav>

          </div>

          <div>
            <b-button v-if="lastEvaluatedKey" @click="getKycEventLogList()">{{ $t("More") }}</b-button>
          </div>

        </div>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CodePreview.vue";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {mapGetters} from "vuex";

export default {
  name: "KycSubmissions",

  components: {
    KTCodePreview
  },

  data() {
    return {


      getPageNumber : 0,
      lastPageNumber : 1,
      pageSize : 10,
      page: 1,
      totalCount : 0,

      searchText : "",
      searchEvent : null,
      isLoading : true,
      dateRange : [ null, null ],
      lastEvaluatedKey: null,

      headers: [
        {
          text: this.$t('EventTime'),
          align: 'start',
          value: 'createTime',
          width: "140px"
        },
        {
          text: this.$t('User'),
          value: 'eventName',
        },
        {
          text: this.$t('SubmissionId'),
          align: 'start',
          value: 'submissionId',
        },
        { text: this.$t('EventType'),
          value: 'eventTrigger'
        },
        {
          text: this.$t('Message'),
          value: 'description'
        },
      ],

      eventLogs: [
        /*
          {
          createTime: "2021-10-13T06:51:05.649Z", //create
          description: "(reawr@rer.com) CODEF FAIL !!!",  //event message
          eventName: "SYSTEM", //event trigger user
          projectId: "685v3v62ba",
          submissionId: "b2c82r9kup5l4vs",
          submissionType: "KYC",
          eventTrigger: "CODEF_FAIL",    //event type
          uuid: "023fa883-ce18-4be5-a033-dd132cc978aa",
        },
        */
      ],

      eventTypeText : {
        liveNess_Under_Score : "Face Image Fraud",
        CODEF_FAIL : "Identity Fraud",
        SUBMISSION_DELETE : "Submission Deleted",
        AML_HIGH_RISK : "AML Red Flag"
      },
      options: [
        {value: null, text: this.$t('NotSelected')},
        {value: "CODEF_FAIL", text: this.$t('IdentityFraud')},
        {value: "liveNess_Under_Score", text: this.$t('FaceImageFraud')},
        {value: "SUBMISSION_DELETE", text: this.$t('SubmissionDeleted')},
        {value: "AML_HIGH_RISK", text: this.$t('AMLRedFlag')},
        {value: "APPROVE_ACCESS", text: this.$t('ApproveAccess')},
        {value: "REVOKE_ACCESS", text: this.$t('RevokeAccess')},
        {value: "ABUSE_WARNING", text: this.$t('AbuseWarning')},
        {value: "PRIVACY_PROTECTION_ON", text: this.$t('PrivacyShieldON')},
        {value: "PRIVACY_PROTECTION_OFF", text: this.$t('PrivacyShieldOFF')},
      ],
    };

  },

  computed : {

    ...mapGetters( {
      selectedProjectObject : "getSelectedProjectObject"
    } ),

    pageLength() {
      return this.$getPageLength( this.totalCount, this.pageSize );
    }
  },

  async mounted(){

    await this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Event Logs" },
      /*{ title: "KYB Detail" }*/
    ]);

    //aml 사용시에만 보여주는 event type
    /*
    if( this.selectedProjectObject.isUseAml ) {
      this.options.push( { value: "AML_HIGH_RISK", text: 'AML Red Flag' } );
      this.eventTypeText.AML_HIGH_RISK = "AML Red Flag";
    }
    */

    await this.getKycEventLogList();

    //this.tableData = result.Items;
  },

  methods : {

    async getKycEventLogList(){

      this.isLoading = true;

      try{
        let projectId = this.$store.getters.getSelectedProjectId;
        if( !projectId ) {
          console.log( "잘못된 요청입니다. pid :: ", projectId );
        }

        let params = {
          projectId: projectId,
        };

        if( this.searchText ) {
          params.searchText = this.searchText;
        }
        if( this.searchEvent ) {
          params.searchEvent = this.searchEvent;
        }

        if( this.dateRange.length > 0 && this.dateRange[0] !== null ) {
          params.startDate = this.dateRange[0];
          // params.endDate = this.$addDay( this.dateRange[1], 1, "YYYY-MM-DD" );
          params.endDate = this.$moment(new Date(this.dateRange[1])).add('days', 1).format('YYYY-MM-DD');
        }

        //  다음 search key 값정보
        if(this.lastEvaluatedKey){
          params.lastEvaluatedKey = JSON.stringify(this.lastEvaluatedKey)
        }

        // let result = await this.$store.dispatch('getKycSubmissionList', params);
        // console.log("result", result);

        let result = await this.$store.dispatch('getKycEventLog', params);
        console.log("result", result);

        if(result.Items && result.Items.length > 0 ) {
          this.eventLogs = [...this.eventLogs, ...result.Items];
        }

        this.totalCount += result.Count; //총 Count
        this.lastEvaluatedKey = result.LastEvaluatedKey || null;

        this.getPageNumber = this.$getPageLength( this.totalCount, this.pageSize );
        if( !result.LastEvaluatedKey || result.Items.length == 0 ) {
          this.lastPageNumber = this.getPageNumber;
        }
        else {
          this.lastPageNumber = 999999;
        }

      }catch (e) {
        console.log("Error in getKycEventLogList", e);
        return;
      }
      finally {
        this.isLoading = false;
      }
    },
    async search(){
      this.lastEvaluatedKey = null;
      this.eventLogs = [];
      this.totalCount = 0;
      await this.getKycEventLogList();
    }
  },
  watch : {
    "$i18n.locale": {
      handler() {
        this.options = [
          {value: null, text: this.$t('NotSelected')},
          {value: "CODEF_FAIL", text: this.$t('IdentityFraud')},
          {value: "liveNess_Under_Score", text: this.$t('FaceImageFraud')},
          {value: "SUBMISSION_DELETE", text: this.$t('SubmissionDeleted')},
          {value: "AML_HIGH_RISK", text: this.$t('AMLRedFlag')},
          {value: "APPROVE_ACCESS", text: this.$t('ApproveAccess')},
          {value: "REVOKE_ACCESS", text: this.$t('RevokeAccess')},
          {value: "ABUSE_WARNING", text: this.$t('AbuseWarning')},
          {value: "PRIVACY_PROTECTION_ON", text: this.$t('PrivacyShieldON')},
          {value: "PRIVACY_PROTECTION_OFF", text: this.$t('PrivacyShieldOFF')},
        ],
        this.headers = [
          {
            text: this.$t('EventTime'),
            align: 'start',
            value: 'createTime',
            width: "140px"
          },
          {
            text: this.$t('User'),
            value: 'eventName',
          },
          {
            text: this.$t('SubmissionId'),
            align: 'start',
            value: 'submissionId',
          },
          { text: this.$t('EventType'),
            value: 'eventTrigger'
          },
          {
            text: this.$t('Message'),
            value: 'description'
          },
        ]
      }
    },
    page() {
      console.log( "page 변경 !!!" )

      //  사용자가 호출하려는 페이지가 현재까지 가져온 마지막데이터보다 뒤에 있으면서 다음 페이지가 존재할 때
      if( this.page >= this.getPageNumber && this.lastEvaluatedKey ) {
        this.getList();
      }

    }
  }
}
</script>

<style>

.v-application ul, .v-application ol {
  padding-left : 0 !important;
}
</style>
